import React from 'react'
import { Modal, Space, Button, ModalProps } from 'antd'
import Style from './modal.module.scss'
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'

export interface CustomModalProps
  extends Omit<ModalProps, 'footer' | 'onOk' | 'onCancel' | 'confirmLoading'> {
  footer?: React.ReactNode | false // 底部内容 false 不显示
  modalCancel?: () => void // 弹窗关闭
  modalSubmit?: () => void // 弹窗提交
  okBtnLoading?: boolean // 提交按钮loading
  useOverrideTitle?: boolean
}

// 模态框组件
const CustomModal: React.FC<CustomModalProps> = (props) => {
  const {
    className = '',
    footer,
    title,
    modalSubmit,
    modalCancel,
    children,
    okText,
    cancelText,
    okBtnLoading,
    useOverrideTitle = true,
    ...restProps
  } = props

  function footerMod() {
    if (footer === undefined) {
      return (
        <div className={Style.footerbox}>
          <Space size={50}>
            <Button
              type="default"
              size="middle"
              style={{ width: '100px' }}
              onClick={() => (modalCancel ? modalCancel() : undefined)}
            >
              {cancelText || '取消'}
            </Button>
            <Button
              type="primary"
              size="middle"
              style={{ width: '100px' }}
              onClick={() => (modalSubmit ? modalSubmit() : undefined)}
              loading={okBtnLoading}
            >
              {okText ? okText : '确定'}
            </Button>
          </Space>
        </div>
      )
    } else if (footer === false) {
      return null
    } else if (footer) {
      return footer
    }
    return null
  }

  return (
    <Modal
      className={`${Style.box} ${className}`}
      width={460} // 宽度
      maskClosable={false} // 点击阴影是否关闭
      keyboard={false} // 是否支持esc
      destroyOnClose // 关闭时销毁 Modal 里的子元素
      bodyStyle={{ padding: '16px' }}
      centered
      cancelText="取消"
      okText="确定"
      getContainer={() => document.body}
      {...restProps}
      title={
        useOverrideTitle ? (
          <div className={Style.headerbox}>{title}</div>
        ) : (
          title
        )
      }
      footer={footerMod()}
      onCancel={modalCancel} // 关闭
    >
      {children}
    </Modal>
  )
}
export default CustomModal

const { confirm, info, success, error, warning } = Modal

interface modalfuncparam {
  title?: string // 标题
  content?: React.ReactNode // 内容
  onOk?: () => void // 确定
  onCancel?: () => void // 取消
  okText?: string
  cancelText?: string
  icon?: React.ReactNode
  className?: string
}

// 询问框
export const CustomerConfirm = (param: modalfuncparam) =>
  confirm({
    icon: param.icon ?? <ExclamationCircleOutlined />,
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    onCancel: param.onCancel,
    okText: param.okText || '确定',
    cancelText: param.cancelText || '取消',
    className: param.className,
  })
// 成功
export const CustomerSuccess = (param: modalfuncparam) =>
  success({
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    okText: param.okText || '确定',
    className: param.className,
  })
// 信息
export const CustomerInfo = (param: modalfuncparam) =>
  info({
    icon: param.icon ?? <InfoCircleOutlined />,
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    okText: param.okText || '确定',
    className: param.className,
  })
// 错误
export const CustomerError = (param: modalfuncparam) =>
  error({
    icon: param.icon ?? <CloseCircleOutlined />,
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    okText: param.okText || '确定',
    className: param.className,
  })
// 警告
export const CustomerWarning = (param: modalfuncparam) =>
  warning({
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    okText: param.okText || '确定',
    className: param.className,
  })
import React from 'react'
import { Modal, Space, Button, ModalProps } from 'antd'
import Style from './modal.module.scss'
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'

export interface CustomModalProps
  extends Omit<ModalProps, 'footer' | 'onOk' | 'onCancel' | 'confirmLoading'> {
  footer?: React.ReactNode | false // 底部内容 false 不显示
  modalCancel?: () => void // 弹窗关闭
  modalSubmit?: () => void // 弹窗提交
  okBtnLoading?: boolean // 提交按钮loading
  useOverrideTitle?: boolean
}

// 模态框组件
const CustomModal: React.FC<CustomModalProps> = (props) => {
  const {
    className = '',
    footer,
    title,
    modalSubmit,
    modalCancel,
    children,
    okText,
    cancelText,
    okBtnLoading,
    useOverrideTitle = true,
    ...restProps
  } = props

  function footerMod() {
    if (footer === undefined) {
      return (
        <div className={Style.footerbox}>
          <Space size={50}>
            <Button
              type="default"
              size="middle"
              style={{ width: '100px' }}
              onClick={() => (modalCancel ? modalCancel() : undefined)}
            >
              {cancelText || '取消'}
            </Button>
            <Button
              type="primary"
              size="middle"
              style={{ width: '100px' }}
              onClick={() => (modalSubmit ? modalSubmit() : undefined)}
              loading={okBtnLoading}
            >
              {okText ? okText : '确定'}
            </Button>
          </Space>
        </div>
      )
    } else if (footer === false) {
      return null
    } else if (footer) {
      return footer
    }
    return null
  }

  return (
    <Modal
      className={`${Style.box} ${className}`}
      width={460} // 宽度
      maskClosable={false} // 点击阴影是否关闭
      keyboard={false} // 是否支持esc
      destroyOnClose // 关闭时销毁 Modal 里的子元素
      bodyStyle={{ padding: '16px' }}
      centered
      cancelText="取消"
      okText="确定"
      getContainer={() => document.body}
      {...restProps}
      title={
        useOverrideTitle ? (
          <div className={Style.headerbox}>{title}</div>
        ) : (
          title
        )
      }
      footer={footerMod()}
      onCancel={modalCancel} // 关闭
    >
      {children}
    </Modal>
  )
}
export default CustomModal

const { confirm, info, success, error, warning } = Modal

interface modalfuncparam {
  title?: string // 标题
  content?: React.ReactNode // 内容
  onOk?: () => void // 确定
  onCancel?: () => void // 取消
  okText?: string
  cancelText?: string
  icon?: React.ReactNode
  className?: string
}

// 询问框
export const CustomerConfirm = (param: modalfuncparam) =>
  confirm({
    icon: param.icon ?? <ExclamationCircleOutlined />,
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    onCancel: param.onCancel,
    okText: param.okText || '确定',
    cancelText: param.cancelText || '取消',
    className: param.className,
  })
// 成功
export const CustomerSuccess = (param: modalfuncparam) =>
  success({
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    okText: param.okText || '确定',
    className: param.className,
  })
// 信息
export const CustomerInfo = (param: modalfuncparam) =>
  info({
    icon: param.icon ?? <InfoCircleOutlined />,
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    okText: param.okText || '确定',
    className: param.className,
  })
// 错误
export const CustomerError = (param: modalfuncparam) =>
  error({
    icon: param.icon ?? <CloseCircleOutlined />,
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    okText: param.okText || '确定',
    className: param.className,
  })
// 警告
export const CustomerWarning = (param: modalfuncparam) =>
  warning({
    title: param.title,
    content: param.content,
    onOk: param.onOk,
    okText: param.okText || '确定',
    className: param.className,
  })
